import { apiConnector } from "./apiConnection";
import { photonEndpoint } from "./apiEndpoints";

export const getSuggestionsApi = async (query) => {
  if (!query) return [];
  try {
    const request = {
      url: photonEndpoint.url,
      method: photonEndpoint.method,
      params: {
        q: query,
        limit: 5,
        lat: 26.9124,
        lon: 75.7873,
      },
    };

    const response = await apiConnector(request);
    if (response.status !== 200) {
        throw new Error("Failed to fetch suggestions");
    }
    return response.data.features || [];
  } catch (error) {
    console.error("Error fetching suggestions:", error);
    return [];
  }
};
